import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../Layout";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";

function Settings(): React.ReactElement {
  const classes = pageStyles();

  const session = useSession();

  return (
    <>
      <Layout sessionData={session}>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Paper className={classes.paper}>
                  <h1>Settings</h1>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </main>
      </Layout>
    </>
  );
}

export default Settings;
